import { createVNode as a, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FilePptTwotoneStandard.js";
import p from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(p, n(e, {
    icon: i
  }), null);
};
t.displayName = "FilePptTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
